import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureLandingSourceKeyFromLocation } from '../../utils/landingSourceKey';

/**
 * Captures landing source_key query params into sessionStorage on every navigation.
 * Mount inside BrowserRouter (e.g. App.tsx).
 */
export function CaptureLandingSourceKey(): null {
  const { search } = useLocation();

  useEffect(() => {
    captureLandingSourceKeyFromLocation(search);
  }, [search]);

  return null;
}
